/** Part 2 slice B — collaboratorMessages through demoMessages */
import { workspaceSubject } from "@Front/Utils/publicSiteBranding";

export const COMMON_UI_I18N_PART2_SLICE_B = {
	collaboratorMessages: {
		updateAdminError: "Impossible de mettre à jour le statut administrateur.",
		updateAdminAddedSuccess: "Administrateur ajouté.",
		updateAdminRemovedSuccess: "Administrateur supprimé.",
		updateRoleError: "Impossible de modifier le rôle.",
		updateRoleSuccess: "Rôle mis à jour.",
		loadCollaboratorError: "Impossible de charger ce collaborateur.",
	},
	clientDashboardMessages: {
		loadFolderError: "Impossible de charger le dossier.",
		loadFoldersError: "Impossible de charger vos dossiers. Réessayez dans quelques instants.",
		loadDocumentsError: "Impossible de charger les documents.",
		certificateFallbackWarning:
			"Le certificat d'ancrage n'a pas pu être joint : seul le PDF a été téléchargé. Réessayez ou contactez votre notaire si le problème persiste.",
		officeChangeRedirectError:
			"Impossible d'accéder aux dossiers de cette étude. L'étude précédente a été restaurée.",
		loadUserFolderError: "Impossible de charger votre dossier.",
		receivedDocumentsUnreadSuffixFromNotary: "Nouveaux document(s) envoyé(s) par votre notaire",
		receivedDocumentsUnreadSuffixFromPeerNotary: "Nouveau(x) document(s) envoyé(s) par un confrère",
		receivedDocumentsUnreadFromNotarySingular: "Nouveau document envoyé par votre notaire",
		receivedDocumentsUnreadFromNotaryPlural: "Nouveaux documents envoyés par votre notaire",
		receivedDocumentsUnreadFromPeerNotarySingular: "Nouveau document envoyé par un confrère",
		receivedDocumentsUnreadFromPeerNotaryPlural: "Nouveaux documents envoyés par un confrère",
		receivedDocumentsReadFromNotary: "Consultez les documents envoyés par votre notaire",
		receivedDocumentsReadFromPeerNotary: "Consultez les documents envoyés par un confrère",
		receivedDocumentsPageTitle: "Documents reçus",
		receivedDocumentsHeadingFromNotary: "Un document vous a été envoyé",
		receivedDocumentsHeadingFromPeerNotary: "Documents reçus d'un confrère",
		receivedDocumentsColumnName: "Nom",
		receivedDocumentsColumnDocumentType: "Type de document",
		receivedDocumentsColumnStatus: "Statut",
		receivedDocumentsColumnSentAt: "Envoyé le",
		receivedDocumentsColumnActions: "Action",
		receivedDocumentsZipLabelFromNotary: "Documents envoyés par le notaire",
		receivedDocumentsZipLabelFromPeerNotary: "Documents envoyés par un confrère",
		additionalDocumentsDescriptionToNotary: "Vous souhaitez envoyer d'autres documents à votre notaire ?",
		additionalDocumentsDescriptionToOwnerNotary: "Vous souhaitez envoyer d'autres documents au notaire propriétaire ?",
		viewDocumentLoadError: "Impossible de charger le document demandé.",
		projectFileNameBeforeExtOne: "(+1 fichier)",
		projectFileNameBeforeExtCount: "(+{{count}} fichiers)",
	},
	clientDashboardToastMessages: {
		downloadDocumentError: "Impossible de télécharger le document.",
		filePreviewError: "Impossible d'afficher ce fichier.",
		fileUploadSuccessSingle: "Fichier uploadé avec succès!",
		fileUploadSuccessMultiple: "Fichiers uploadés avec succès!",
		fileDeleteSuccess: "Fichier supprimé avec succès!",
		fileUploadTimeoutVerify:
			"Le téléversement a expiré. Vérifiez l'état du document dans la liste : le fichier peut avoir été enregistré malgré tout.",
	},
	createCustomerNoteMessages: {
		loadFolderError: "Impossible de charger les informations du dossier.",
		loadCustomerError: "Impossible de charger les informations du client.",
		saveNoteError: "Impossible d'enregistrer la note.",
	},
	folderInformationMessages: {
		inotNoSelectionWarning: "Sélectionnez au moins un document validé avant l'envoi iNot.",
		inotPartialWarningPrefix: "document(s) n'ont pas pu être envoyés.",
		inotSendSuccessTitle: "Envoi iNot terminé",
		inotSendSuccessSuffix: "document(s) envoyé(s) vers iNot.",
		reminderSendSuccess: "La relance a été envoyée avec succès.",
		reminderSendError: "Impossible d'envoyer la relance",
		invitedReceivedLoadDocumentsError: "Impossible de charger les documents.",
		invitedReceivedLoadFolderError: "Impossible de charger le dossier.",
		invitedReceivedDownloadError: "Téléchargement impossible.",
		invitedReceivedBulkDownloadError: "Une erreur est survenue lors du téléchargement des documents.",
	},
	deedTypesMessages: {
		missingCurrentOfficeError: `Impossible de déterminer ${workspaceSubject()} courant.`,
		invalidInputError: "Les données saisies sont invalides.",
		createFailedError: "Le type d'acte n'a pas pu être créé.",
		unexpectedError: "Une erreur inattendue est survenue.",
		notFoundError: "Type d'acte introuvable.",
		saveChangesError: "Impossible d'enregistrer les modifications.",
		loadSingleError: "Impossible de charger ce type d'acte.",
		loadWithDocumentsError: "Impossible de charger ce type d'acte ou la liste des documents.",
		archiveSuccess: "Le type d'acte a été archivé avec succès.",
		archiveError: "Impossible de supprimer ce type d'acte.",
		saveDocumentsSuccess: "La description et les documents ont été enregistrés.",
		saveDocumentsError: "Impossible d'enregistrer la description ou les documents associés.",
	},
	folderViewDocumentsMessages: {
		validatePermissionDenied: "Vous n'avez pas les droits pour valider ce document.",
		refusePermissionDenied: "Vous n'avez pas les droits pour refuser ce document.",
		downloadPermissionDenied: "Vous n'avez pas les droits pour télécharger ce document.",
		loadDocumentError: "Impossible de charger le document demandé.",
		filePreviewLoadError: "Impossible de charger l'aperçu du fichier.",
		validateSuccessTitle: "Document validé",
		validateSuccessDescription: "Le document est maintenant disponible au téléchargement.",
		refuseSuccessTitle: "Document refusé",
		refuseSuccessDescription: "Le client sera notifié du motif de refus.",
	},
	demoMessages: {
		alerts: {
			title: "Alerts",
			alertTitle: "Alert line which displays the main function or reason of the alert.",
			alertDescription: "Description",
			alertButton: "Button",
		},
		tooltip: {
			title: "Tooltip",
			longText: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec nec",
			shortText: "Lorem ipsum dolor",
			helperChildText: "Work for any children",
		},
		dragAndDrop: {
			title: "Drag and Drop",
			uploadTitle: "Upload de document",
			uploadDescription: "Description",
		},
		formOptions: {
			option1: "Option 1",
			option2: "Option 2",
			option3: "Option 3",
			option4: "Option 4",
			subtext: "Subtext",
			label: "Label",
			placeholder: "Placeholder",
		},
		checkboxes: {
			title: "Checkboxes",
			defaultLabel: "Default",
			checkedLabel: "Checked",
			disabledLabel: "Disabled",
			checkedDisabledLabel: "Checked & Disabled",
			description: "Description",
			tooltip: "test",
		},
		radioBoxes: {
			title: "Radio boxes",
			value: "new client",
			description: "Test",
			label: "Créer un document",
			tooltip: "test",
		},
		autocomplete: {
			title: "Autocomplete",
			multiSelectTitle: "Autocomplete Multi Select",
		},
		dropdown: {
			title: "Dropdown",
		},
		inputs: {
			title: "Inputs",
			numberPickerDescription: "Number picker avec min a 1 et max a 10",
			label: "Label",
			placeholder: "Placeholder",
			withoutCopyLabel: "Without copy",
			disabledLabel: "Disabled",
			disabledWithoutCopyLabel: "Disabled without copy",
			textareaLabel: "Textarea",
		},
		toast: {
			title: "Toast",
			toasterTitle: "Title toaster",
			toasterDescription: "Description",
			sendToastCta: "Send Toast",
			sendInfoCta: "Send Toast Info",
			sendSuccessCta: "Send Toast Success",
			sendWarningCta: "Send Toast Warning",
			sendErrorCta: "Send Toast Error",
			sendLoadingCta: "Send Toast Loading",
			loggedOutCta: "Logged Out",
		},
	},
} as const;
